export default "__VITE_ASSET__BaBc3LLI__"